if (process.env.REACT_APP_AUTH_METHOD === 'Basic')
  // import client, { getFetchConfigApi, getAuthHeadersApi, getCurrentUser } from './api-client-basic';
  var {
    client,
    getFetchConfigApi,
    getAuthHeadersApi,
    getCurrentUser,
  } = require('./api-client-basic.js');
else
  // import client, { getFetchConfigApi, getAuthHeadersApi, getCurrentUser } from './api-client-jwt';
  var {
    client,
    getFetchConfigApi,
    getAuthHeadersApi,
    getCurrentUser,
  } = require('./api-client-jwt');
import { localStorageKey } from 'utils/constants.js';

/** Относительный путь для логина. */
const LOGIN_ENDPOINT = 'login';
/** Относительный путь для обновления access-token. */
const REFRESH_ENDPOINT = 'refresh';
/** Относительный путь для выхода. */
const LOGOUT_ENDPOINT = 'logout';
/** Относительный путь для получения текущего пользователя. */
const USER_ENDPOINT = 'users/me';

let isRefreshing = false;
let refreshPromise = null;

// const localStorageKey = 'auth-token';

/**
 * Возвращает сохранённый access token из localStorage.
 * @returns {string|null} Токен или null.
 */
const getToken = () => localStorage.getItem(localStorageKey);

/**
 * Возвращает конфигурацию fetch с актуальным токеном.
 * @param {string} method - HTTP-метод.
 * @returns {Object} Конфигурация запроса.
 */
const getFetchConfig = (method) => getFetchConfigApi(method, getToken());

/**
 * Возвращает заголовки Authorization с актуальным токеном.
 * @returns {Object} Заголовки Authorization.
 */
const getAuthHeaders = () => getAuthHeadersApi(getToken());

/**
 * Возвращает информацию о текущем пользователе.
 * При ошибке очищает локальное состояние.
 * @returns {Promise<Object>} Данные пользователя.
 */
const getUser = async () => {
  try {
    return await getCurrentUser();
  } catch (error) {
    logout();
    return Promise.reject(error);
  }
};

/**
 * Выполняет аутентификацию и сохраняет access token.
 * @param {{login: string, password: string}} params - Учетные данные.
 * @returns {Promise<string>} Полученный токен.
 */
const login = async ({ login, password }) => {
  // return client(`http://localhost:8000/${LOGIN_ENDPOINT}`, { login, password }).then(
  console.log('REACT_APP_AUTH_URL=', process.env.REACT_APP_AUTH_URL);
  const { token } = await client(`${process.env.REACT_APP_AUTH_URL}/${LOGIN_ENDPOINT}`, { login, password });
  localStorage.setItem(localStorageKey, token);
  return token;
};

/**
 * Выполняет выход пользователя и очищает локальные токены.
 * @returns {Promise<void>} Промис завершения операции.
 */
const logout = async () => {
  const token = getToken();
  if (!token) return Promise.resolve();

  try {
    await fetch(`${process.env.REACT_APP_AUTH_URL}/${LOGOUT_ENDPOINT}`, {
      // await fetch(`http://localhost:8000/${LOGOUT_ENDPOINT}`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-type': 'application/json',
        ...getAuthHeaders(),
      },
    });
  } catch (error) {
    console.error('Ошибка при выходе: ', error);
  } finally {
    localStorage.removeItem(localStorageKey);
  }

  return Promise.resolve();
};

/**
 * Обновляет access token, сериализуя параллельные запросы.
 * @returns {Promise<string>} Новый access token.
 */
const refresh = async () => {
  if (isRefreshing) {
    return refreshPromise;
  }

  isRefreshing = true;
  refreshPromise = (async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_AUTH_URL}/${REFRESH_ENDPOINT}`, {
        method: 'POST',
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Refresh token request failed');
      }

      const data = await response.json();
      localStorage.setItem(localStorageKey, data.access_token);
      return data.access_token;
    } finally {
      isRefreshing = false;
      refreshPromise = null;
    }
  })();
  return refreshPromise;
  // const { token } = await client(`${process.env.REACT_APP_AUTH_URL}/${REFRESH_ENDPOINT}`);
  // // return client(`http://localhost:8000/${REFRESH_ENDPOINT}`).then(({ token }) => {
  // localStorage.setItem(localStorageKey, token);
  // return token;
};

export { login, logout, refresh, getToken, getUser, getFetchConfig, getAuthHeaders };
